import { Button, Stack } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onSave: () => void;
  onCancel: () => void;
  hasError: boolean;
};

const RESOURCES = Resources.Components.Merchant.Facilities.Form.OpeningHours;

export const DayEditActions = ({ onSave, onCancel, hasError }: Props) => {
  const { t } = useResource();

  return (
    <Stack direction={["column", "row"]} gap={2} mt={2}>
      <Button
        onClick={onSave}
        variant="contained"
        color="primary"
        sx={{
          width: ["100%", "auto"],
          "&.Mui-disabled": {
            color: ({ palette }) => palette.common.white,
          },
        }}
        disabled={hasError}
      >
        {t(RESOURCES.Save)}
      </Button>
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{ width: ["100%", "auto"] }}
      >
        {t(RESOURCES.Cancel)}
      </Button>
    </Stack>
  );
};
